module.exports = __webpack_public_path__ + "media/landing_page/fss2-1b695696.jpg";